import { __exports as r } from "../../../../_virtual/find-best-match.js";
Object.defineProperty(r, "__esModule", { value: !0 });
r.findBestMatch = void 0;
function u(e) {
  var t = e.filter(function(n) {
    return n.matchStrength;
  }).length;
  return t > 0 && t === e.length;
}
function i(e) {
  return u(e) ? e.reduce(function(t, n) {
    return !t || Number(t.matchStrength) < Number(n.matchStrength) ? n : t;
  }) : null;
}
r.findBestMatch = i;
export {
  r as default
};
